import { render, staticRenderFns } from "./SysClientApiKey.vue?vue&type=template&id=06fcd40a&scoped=true"
import script from "./SysClientApiKey.vue?vue&type=script&lang=js"
export * from "./SysClientApiKey.vue?vue&type=script&lang=js"
import style0 from "./SysClientApiKey.vue?vue&type=style&index=0&id=06fcd40a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fcd40a",
  null
  
)

export default component.exports